export const fetchVocab = {
  pathname: id => '/api/v4/vocab/industries'
}
